/* eslint-disable no-redeclare */
/**
 * 加密盐混淆
 * @returns {Array} ['ngappfgabcdefg12', 'JfIR9RofenbQoTO', '0102030405060708', 'wsQ565RjVK0fGQfvxetzJJ8uRQ3mUwp6']
 */

export default (function (g, i) {
  var u = g.length
  var j = []
  for (var v = 0; v < u; v++) {
    j[v] = g.charAt(v)
  }
  for (var v = 0; v < u; v++) {
    var t = i * (v + 299) + (i % 47514)
    var c = i * (v + 565) + (i % 51546)
    var b = t % u
    var p = c % u
    var r = j[b]
    j[b] = j[p]
    j[p] = r
    i = (t + c) % 4692730
  }
  var f = String.fromCharCode(127)
  var q = ''
  var y = '\x25'
  var w = '\x23\x31'
  var h = '\x25'
  var x = '\x23\x30'
  var e = '\x23'
  return j
    .join(q)
    .split(y)
    .join(f)
    .split(w)
    .join(h)
    .split(x)
    .join(e)
    .split(f)
})(
  'pg6pUf1aRcfewgG2RJ5IT9noxe2btoRO%0a0d0b0%0Q040808%3sp505fjQK1fRQfvgefzJJnuVQ7m3w66',
  216006
)
